/**
 *   Generated file. Do not edit
 */

import { LoginCredential } from './models';
import { LoginCredentialHashed } from './models';
import { HostProtocol } from '@iotize/tap';
import { SecurityOptions } from './models';
import { NfcPairingMode } from './models';
import { WirelessPairingOptions } from './models';
import { LowPowerOptimizationLevel } from './models';
import { CpuFrequencyOptions } from './models';
import { CpuFrequencySpeed } from '@iotize/tap';
import { PowerOptimizationOptions } from './models';
import { ServiceCode } from './models';
import { NetworkOptions } from './models';
import { NfcConnectionPriority } from './models';
import { ProtocolMaxFrameSize } from './models';
import { MultiRequestFrame } from './models';
import { MultiResponseFrame } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  login: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/login',
    path: '/1024//0',
    bodyEncoder: allConverters.loginCredential,
  } as ServiceCallType<LoginCredential, void>,

  loginWithHash: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/login-with-hash',
    path: '/1024//0',
    bodyEncoder: allConverters.loginCredentialHashed,
  } as ServiceCallType<LoginCredentialHashed, void>,

  logout: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/logout',
    path: '/1024//1',
  } as ServiceCallType<void, void>,

  getCurrentProfileId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/current-profile/id',
    path: '/1024//2',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  getCurrentHostProtocol: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/current-host-protocol',
    path: '/1024//3',
    responseBodyDecoder: allConverters.hostProtocol,
  } as ServiceCallType<void, HostProtocol>,

  putCurrentHostProtocol: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/current-host-protocol',
    path: '/1024//3',
    bodyEncoder: allConverters.hostProtocol,
  } as ServiceCallType<HostProtocol, void>,

  getUID: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/uid',
    path: '/1024//5',
  } as ServiceCallType<void, Uint8Array>,

  loginWithUID: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/uid',
    path: '/1024//5',
  } as ServiceCallType<Uint8Array, void>,

  keepAlive: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/keep-alive',
    path: '/1024//4',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  postKeepAlive: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/keep-alive',
    path: '/1024//4',
  } as ServiceCallType<void, void>,

  getSecurityOptions: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/security-options',
    path: '/1024//6',
    responseBodyDecoder: allConverters.securityOptions,
  } as ServiceCallType<void, SecurityOptions>,

  putSecurityOptions: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/security-options',
    path: '/1024//6',
    bodyEncoder: allConverters.securityOptions,
  } as ServiceCallType<SecurityOptions, void>,

  getCurrentGroupId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/current-group-id',
    path: '/1024//7',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  getBundleIdSwdDirectAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-swd-direct-access',
    path: '/1024//100',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdSwdDirectAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-swd-direct-access',
    path: '/1024//100',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdSerialAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-serial-access',
    path: '/1024//101',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdSerialAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-serial-access',
    path: '/1024//101',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdModbusDirectAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-modbus-direct-access',
    path: '/1024//102',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdModbusDirectAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-modbus-direct-access',
    path: '/1024//102',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdTapnpassControlAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-tapnpass-control-access',
    path: '/1024//103',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdTapnpassControlAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-tapnpass-control-access',
    path: '/1024//103',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdFirmwareUpdateAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-firmware-update-access',
    path: '/1024//104',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdFirmwareUpdateAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-firmware-update-access',
    path: '/1024//104',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdMqttIdsAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-mqtt-ids-access',
    path: '/1024//105',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdMqttIdsAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-mqtt-ids-access',
    path: '/1024//105',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdVariableConfigAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-variable-config-access',
    path: '/1024//106',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdVariableConfigAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-variable-config-access',
    path: '/1024//106',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getBundleIdFileSystemAccess: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/bundle-id-file-system-access',
    path: '/1024//107',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putBundleIdFileSystemAccess: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/bundle-id-file-system-access',
    path: '/1024//107',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getConfigFormatVersion: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/config-format-version',
    path: '/1024//8',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putConfigFormatVersion: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/config-format-version',
    path: '/1024//8',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getAppName: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/app-name',
    path: '/1024//9',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putAppName: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/app-name',
    path: '/1024//9',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getConfigVersion: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/config-version',
    path: '/1024//10',
    responseBodyDecoder: allConverters.stringVersion,
  } as ServiceCallType<void, string>,

  putConfigVersion: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/config-version',
    path: '/1024//10',
    bodyEncoder: allConverters.stringVersion,
  } as ServiceCallType<string, void>,

  reloadConfig: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/config-version',
    path: '/1024//10',
  } as ServiceCallType<void, void>,

  getAppPath: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/app-path',
    path: '/1024//11',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putAppPath: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/app-path',
    path: '/1024//11',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  postAppPath: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/app-path',
    path: '/1024//11',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getNfcPairingMode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/nfc/pairing-mode',
    path: '/1024//13',
    responseBodyDecoder: allConverters.nfcPairingMode,
  } as ServiceCallType<void, NfcPairingMode>,

  putNfcPairingMode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/nfc/pairing-mode',
    path: '/1024//13',
    bodyEncoder: allConverters.nfcPairingMode,
  } as ServiceCallType<NfcPairingMode, void>,

  getPairingOptions: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/pairing-options',
    path: '/1024//13',
    responseBodyDecoder: allConverters.wirelessPairingOptions,
  } as ServiceCallType<void, WirelessPairingOptions>,

  postPairingOptions: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/pairing-options',
    path: '/1024//13',
    bodyEncoder: allConverters.wirelessPairingOptions,
  } as ServiceCallType<WirelessPairingOptions, void>,

  putPairingOptions: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/pairing-options',
    path: '/1024//13',
    bodyEncoder: allConverters.wirelessPairingOptions,
  } as ServiceCallType<WirelessPairingOptions, void>,

  getPowerOptimisationLevel: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/power-optimisation-level',
    path: '/1024//14',
    responseBodyDecoder: allConverters.lowPowerOptimizationLevel,
  } as ServiceCallType<void, LowPowerOptimizationLevel>,

  putPowerOptimisationLevel: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/power-optimisation-level',
    path: '/1024//14',
    bodyEncoder: allConverters.lowPowerOptimizationLevel,
  } as ServiceCallType<LowPowerOptimizationLevel, void>,

  getCpuFrequencyOptions: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/cpu-frequency-options',
    path: '/1024//141',
    responseBodyDecoder: allConverters.cpuFrequencyOptions,
  } as ServiceCallType<void, CpuFrequencyOptions>,

  putCpuFrequencyOptions: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/cpu-frequency-options',
    path: '/1024//141',
    bodyEncoder: allConverters.cpuFrequencySpeed,
  } as ServiceCallType<CpuFrequencySpeed, void>,

  getPowerOptimisationOptions: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/power-optimisation-options',
    path: '/1024//142',
    responseBodyDecoder: allConverters.powerOptimizationOptions,
  } as ServiceCallType<void, PowerOptimizationOptions>,

  putPowerOptimisationOptions: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/power-optimisation-options',
    path: '/1024//142',
    bodyEncoder: allConverters.powerOptimizationOptions,
  } as ServiceCallType<PowerOptimizationOptions, void>,

  getMaxLowPowerTime: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/max-low-power-time',
    path: '/1024//33',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  putMaxLowPowerTime: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/max-low-power-time',
    path: '/1024//33',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,

  getAutoRebootTimeout: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/auto-reboot-timeout',
    path: '/1024//123',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putAutoRebootTimeout: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/auto-reboot-timeout',
    path: '/1024//123',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getAuthorizedHostProtocol: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/authorized-host-protocol',
    path: '/1024//17',
    responseBodyDecoder: allConverters.hostProtocolArray,
  } as ServiceCallType<void, HostProtocol[]>,

  putAuthorizedHostProtocol: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/authorized-host-protocol',
    path: '/1024//17',
    bodyEncoder: allConverters.hostProtocolArray,
  } as ServiceCallType<HostProtocol[], void>,

  getConfigFormatFirmwareVersion: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/config-format-firmware-version',
    path: '/1024//18',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  getUniversalLink: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/universal-link',
    path: '/1024//19',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putUniversalLink: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/universal-link',
    path: '/1024//19',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  postUniversalLink: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/universal-link',
    path: '/1024//19',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  listObjectInstances: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/list-object-instances',
    path: '/1024//140',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, Uint8Array>,

  getAvailableHostProtocols: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/available-host-protocols',
    path: '/1024//21',
    responseBodyDecoder: allConverters.hostProtocolArray,
  } as ServiceCallType<void, HostProtocol[]>,

  getDisabledServices: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/disabled-services',
    path: '/1024//75',
    responseBodyDecoder: allConverters.serviceCodeArray,
  } as ServiceCallType<void, ServiceCode[]>,

  postDisabledServices: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/disabled-services',
    path: '/1024//75',
    bodyEncoder: allConverters.serviceCodeArray,
  } as ServiceCallType<ServiceCode[], void>,

  getNetworkOptions: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/network-options',
    path: '/1024//127',
    responseBodyDecoder: allConverters.networkOptions,
  } as ServiceCallType<void, NetworkOptions>,

  putNetworkOptions: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/network-options',
    path: '/1024//127',
    bodyEncoder: allConverters.networkOptions,
  } as ServiceCallType<NetworkOptions, void>,

  getRadioMixEnabled: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/radio-mix-enabled',
    path: '/1024//132',
    responseBodyDecoder: allConverters.uint8,
  } as ServiceCallType<void, number>,

  putRadioMixEnabled: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/radio-mix-enabled',
    path: '/1024//132',
    bodyEncoder: allConverters.uint8,
  } as ServiceCallType<number, void>,

  getNfcConnectionPriority: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/nfc_connection_priority',
    path: '/1024//24',
    responseBodyDecoder: allConverters.nfcConnectionPriority,
  } as ServiceCallType<void, NfcConnectionPriority>,

  postNfcConnectionPriority: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/nfc_connection_priority',
    path: '/1024//24',
    bodyEncoder: allConverters.nfcConnectionPriority,
  } as ServiceCallType<NfcConnectionPriority, void>,

  putNfcConnectionPriority: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/nfc_connection_priority',
    path: '/1024//24',
    bodyEncoder: allConverters.nfcConnectionPriority,
  } as ServiceCallType<NfcConnectionPriority, void>,

  getNfcAutologProfileId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/nfc-autolog-profile-id',
    path: '/1024//43',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putNfcAutologProfileId: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/nfc-autolog-profile-id',
    path: '/1024//43',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getHostInactivityPeriod: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/host-inactivity-period',
    path: '/1024//34',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putHostInactivityPeriod: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/host-inactivity-period',
    path: '/1024//34',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getApplicationData: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/application-data',
    path: '/1024//36',
  } as ServiceCallType<void, Uint8Array>,

  putApplicationData: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/application-data',
    path: '/1024//36',
  } as ServiceCallType<Uint8Array, void>,

  postApplicationData: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/application-data',
    path: '/1024//36',
  } as ServiceCallType<Uint8Array, void>,

  getProductKey: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/product-key',
    path: '/1024//60',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  getCurrentHostProtocolMaxFrameSize: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/current-host-protocol-max-frame-size',
    path: '/1024//88',
    responseBodyDecoder: allConverters.protocolMaxFrameSize,
  } as ServiceCallType<void, ProtocolMaxFrameSize>,

  executeMultiRequestFrame: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/multi-request-frame',
    path: '/1024//89',
    responseBodyDecoder: allConverters.multiResponseFrame,
    bodyEncoder: allConverters.multiRequestFrame,
  } as ServiceCallType<MultiRequestFrame, MultiResponseFrame>,

  putCertificatePublicKey: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/certificate/public-key',
    append: true,
    path: '/1024//37',
  } as ServiceCallType<Uint8Array, void>,

  putCertificatePrivateKey: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/certificate/private-key',
    append: true,
    path: '/1024//38',
  } as ServiceCallType<Uint8Array, void>,

  putCertificateRootKey: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/certificate/root-key',
    append: true,
    path: '/1024//39',
  } as ServiceCallType<Uint8Array, void>,

  getProductCode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/product-code',
    path: '/1024//84',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putProductCode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/product-code',
    path: '/1024//84',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getSpecialFeatureProfile: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/interface/special-feature/{featureId}',
    path: '/1024//{featureId}',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  setSpecialFeatureProfile: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/interface/special-feature/{featureId}',
    path: '/1024//{featureId}',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  putSpecialFeatureProfile: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/interface/special-feature/{featureId}',
    path: '/1024//{featureId}',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,
};
